import { useRef, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

import Dropdown from "components/OptionsCard/Dropdown";
import { Option } from "components/OptionsCard/typings";
import ChangeKindIcon from "assets/icons/mode_edit.svg?react";
import { IDispatchListItem } from "dto/Mailroom/IDispatchChart";

import styles from "./outgoing.module.scss";

interface Props {
  item: IDispatchListItem;
  onChangeKind: (item: IDispatchListItem) => void;
}

// Menu „więcej" (ikona kebab) dla wiersza listy „Do wysyłki" — wzorzec jak w
// AddressBookVerificationsManager/MenuCell (ellipsis + współdzielony Dropdown).
// Trzyma własny stan/otwarcie i ref kotwicy (Dropdown → Popper kotwiczy do refWrapper).
const OutgoingRowMenu = ({ item, onChangeKind }: Props) => {
  const [open, setOpen] = useState(false);
  const refWrapper = useRef<HTMLDivElement>(null);

  const options: Option[] = [
    {
      name: "Zmień sposób nadania",
      Icon: ChangeKindIcon,
      callback: () => onChangeKind(item),
      additional: false,
      isEnabled: true,
      canMultiple: false,
    },
  ];

  return (
    <div className={styles.rowMenu}>
      <div
        ref={refWrapper}
        className={styles.rowMenuTrigger}
        title="Więcej"
        onClick={(e) => {
          // wiersz jest <label> — nie przełączaj checkboxa / podglądu.
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        onDoubleClick={(e) => e.stopPropagation()}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      {open && (
        <Dropdown
          toggle={() => setOpen(false)}
          options={options}
          refWrapper={refWrapper}
          rightSide={true}
          scrollWrapper={refWrapper}
          showOptions={open}
          selectedElements={[]}
          setSelectedElements={() => {}}
        />
      )}
    </div>
  );
};

export default OutgoingRowMenu;
